export default "__VITE_ASSET__BsKZtVr9__"